'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _location_service = require('../services/location_service.js');

var _location_service2 = _interopRequireDefault(_location_service);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _ramda = require('ramda');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _fund_utility = require('../../../packages/common-utilities/src/fund_utility');

var _reactIntl = require('react-intl');

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _withBreakpointResizeListener = require('../hoc/withBreakpointResizeListener');

var _sanitize_utility = require('../../../packages/common-utilities/src/sanitize_utility.js');

var _sanitize_utility2 = _interopRequireDefault(_sanitize_utility);

var _constants = require('../../../packages/common-utilities/src/constants.js');

var _constants2 = _interopRequireDefault(_constants);

var _collection_utility = require('common-utilities/src/collection_utility');

var _tracking_utility = require('common-utilities/src/tracking_utility');

var _url_utility = require('common-utilities/src/url_utility');

var _url_utility2 = _interopRequireDefault(_url_utility);

var _accessibility_utility = require('../../../packages/common-utilities/src/accessibility_utility');

var _accessibility_utility2 = _interopRequireDefault(_accessibility_utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapIndexed = (0, _ramda.addIndex)(_ramda.map);

var SEARCH_USAGE = false;

var JumpToFunds = function (_React$Component) {
  _inherits(JumpToFunds, _React$Component);

  function JumpToFunds(props) {
    _classCallCheck(this, JumpToFunds);

    var _this = _possibleConstructorReturn(this, (JumpToFunds.__proto__ || Object.getPrototypeOf(JumpToFunds)).call(this, props));

    _this.autoSuggest = _this.autoSuggest.bind(_this);
    _this.handleEnterKey = _this.handleEnterKey.bind(_this);
    _this.handleOnFocus = _this.handleOnFocus.bind(_this);
    _this.handleOnBlur = _this.handleOnBlur.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.resetSearch = _this.resetSearch.bind(_this);
    _this.state = {
      searchResults: [],
      searchText: '',
      autocompleteFundData: (0, _ramda.isNil)(props.autocompleteFundData) ? [] : props.autocompleteFundData,
      errorMsg: '',
      cursor: 0,
      searchBoxFocus: false,
      searchBoxPlaceholder: _string_utility2.default.getLocalizedString(_this.props.intl, 'Jump to a fund', 'pdp-jump-to-a-fund-search-placeholder', { role: props.role }),
      style: '',
      prefix: '',
      hoveredId: '',
      searchBoxAriaLabel: _string_utility2.default.getLocalizedString(_this.props.intl, 'Jump to a fund', 'pdp-jump-to-a-fund-search-placeholder', { role: props.role })
    };
    _location_service2.default.setTargetWindowObject(_this.props.window);
    return _this;
  }

  _createClass(JumpToFunds, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getAutocompleteFundData();

      this.jumpToFundWrapper.parents().find('picture.band-bg').find('img.band-image').css("min-height", "initial");
      var bandElement = this.jumpToFundWrapper.parents().find('.container-fluid.band').children().has(this.jumpToFundWrapper).parent();
      bandElement.css("z-index", "102");
      (0, _jquery2.default)("<div style='clear: both;'></div>").insertAfter(bandElement);

      if (this.props.appType === 'jtf' || this.props.appType === "card") {
        this.jumpToFundWrapper.css("padding", "0");
        this.jumpToFundWrapper.parents().find('#parentContainer').css({
          "position": "absolute",
          "width": "83%",
          "background-color": "#f2f2f2"
        });
        this.jumpToFundWrapper.parents().find('div.module.npe.jtf').siblings(":last").css({
          "width": "100%",
          "margin-top": "80px"
        });
        (0, _jquery2.default)('.background-soft-grey').css("margin-top", "86px");
        this.jumpToFundWrapper.parents().find('div.module.npe.jtf').parent().siblings("div.fifty").css("position", "static");
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (!(0, _ramda.equals)(prevProps.intl, this.props.intl)) {
        this.setState({
          searchBoxPlaceholder: _string_utility2.default.getLocalizedString(this.props.intl, 'Jump to a fund', 'pdp-jump-to-a-fund-search-placeholder', { role: this.props.role })
        });
      }
    }
  }, {
    key: 'autoSuggest',
    value: function autoSuggest(e) {
      var _this2 = this;

      this.props.onShowDropdown();
      this.setState({ searchText: e.target.value });
      var searchText = e.target.value.toLowerCase();

      var autoCompleteData = this.state.autocompleteFundData || [];
      if (autoCompleteData.length === 0) {
        autoCompleteData = this.props.autocompleteFundData;
      }
      this.setState({ hoveredId: '' });

      if (autoCompleteData.length === 0) {
        this.setState({ errorMsg: 'Loading, Please wait ........' });
      } else {
        var searchTextLength = e.target.value.length;
        var showShareClassName = this.props.showShareClassName;

        var searchResultsByTickerOrCusipOrNumber = [];
        var searchResults = [];
        clearTimeout(this.delayTimer);
        if (this.props.isStickyHeaderVisible) {
          this.props.tooltip.closeTooltip();
        }
        this.delayTimer = setTimeout(function () {
          _this2.setState({ errorMsg: '' });
          if (searchTextLength > 0) {
            if (!SEARCH_USAGE) {
              var trackingObject = {
                "eventCategory": _tracking_utility.TrackingUtility.getEventCategory(_this2.props.appType),
                "eventAction": "jump to a fund",
                "eventLabel": "type"
              };
              _tracking_utility.TrackingUtility.trackEvent(trackingObject);
              SEARCH_USAGE = true;
            }
            searchResultsByTickerOrCusipOrNumber = _collection_utility.CollectionUtility.filter(autoCompleteData, function (item) {
              return _this2.isSearchTextPresentInIdProperties(item, searchText) || _this2.isSearchTextPresentInShareclassName(item, searchText, showShareClassName);
            });
            searchResults = _this2.filterByLanguage(_this2.props.language, searchResultsByTickerOrCusipOrNumber);

            if (searchResults.length === 0) {
              searchResults = _this2.filterBySynonymAndOnlyReturnResultsWithDefaultShareclass(searchText);
            }

            if (searchResults.length > 0 && !(0, _ramda.isNil)(searchResults[0].translatedShareclassName)) {
              var languageTyped = void 0;
              if (!(0, _ramda.isNil)(searchResults[0].translatedShareclassName[_this2.props.language])) {
                languageTyped = _this2.props.language;
              } else if (!(0, _ramda.isNil)(_this2.languageTyped(searchText, searchResults[0].translatedShareclassName))) {
                languageTyped = _this2.languageTyped(searchText, searchResults[0].translatedShareclassName);
              } else {
                languageTyped = "en";
              }
              languageTyped = _url_utility2.default.getLanguageOverrideForJumpToFundResults(_this2.props.country) || languageTyped;
              searchResults = (0, _ramda.sortBy)((0, _ramda.path)(['translatedShareclassName', languageTyped]))(searchResults);
            } else {
              searchResults = (0, _ramda.sortWith)([(0, _ramda.ascend)((0, _ramda.prop)('name')), (0, _ramda.ascend)((0, _ramda.prop)('sortOrder'))])(searchResults);
            }

            if (searchResults.length > 10) {
              searchResults = searchResults.slice(0, 10);
            }
          }
          _this2.setState({ searchResults: searchResults, hoveredId: 'suggestionItem-0' }, _this2.displayErrorMsg);
        }, 250);
      }
    }
  }, {
    key: 'isSearchTextPresentInIdProperties',
    value: function isSearchTextPresentInIdProperties(item, searchText) {
      return (_collection_utility.CollectionUtility.includes(item.ticker.toLowerCase(), searchText) || _collection_utility.CollectionUtility.includes(item.cusip.toLowerCase(), searchText) || _collection_utility.CollectionUtility.includes(item.shareclassNumber, searchText) || _collection_utility.CollectionUtility.includes((0, _ramda.isNil)(item.sedol) ? "" : item.sedol.toLowerCase(), searchText) || _collection_utility.CollectionUtility.includes((0, _ramda.isNil)(item.wkn) ? "" : item.wkn.toLowerCase(), searchText)) && item.isSynonym === false;
    }
  }, {
    key: 'isSearchTextPresentInShareclassName',
    value: function isSearchTextPresentInShareclassName(item, searchText, showShareClassName) {
      searchText = searchText.replace(/[\(\)\-\[\]]/g, ' ').replace(/\s{2,}/g, ' ').toLowerCase();
      return ((showShareClassName ? _collection_utility.CollectionUtility.includes(item.shareclassName.replace(/[\(\)\-\[\]]/g, ' ').replace(/\s{2,}/g, ' ').toLowerCase(), searchText) : _collection_utility.CollectionUtility.includes(item.name.replace(/[\(\)\-\[\]]/g, ' ').replace(/\s{2,}/g, ' ').toLowerCase(), searchText)) || this.checkIfItemContainsTextInLanguages(item.translatedShareclassName, searchText)) && item.sortOrder === 0 && item.isSynonym === false;
    }
  }, {
    key: 'displayErrorMsg',
    value: function displayErrorMsg() {
      if (this.state.searchResults.length === 0 && this.state.searchText.length > 0) {
        var errorMsg = _string_utility2.default.renderFormattedLabel('No results found for "{SEARCH}". Enter a valid fund name, ticker or CUSIP.', 'pdp-jump-to-fund-empty-results', { SEARCH: this.state.searchText });
        this.setState({ errorMsg: errorMsg });
      }
    }
  }, {
    key: 'languageTyped',
    value: function languageTyped(searchText, data) {
      if (!(0, _ramda.isNil)(data)) {
        for (var language in data) {
          if (!(0, _ramda.isNil)(data[language]) && _collection_utility.CollectionUtility.includes(data[language].toLowerCase(), searchText.toLowerCase())) {
            return language;
          }
        }
      }
      return null;
    }
  }, {
    key: 'filterByLanguage',
    value: function filterByLanguage(language, data) {
      var results = _collection_utility.CollectionUtility.filter(data, function (item) {
        return item.language === language;
      });
      return results.length === 0 ? data : results;
    }
  }, {
    key: 'checkIfItemContainsTextInLanguages',
    value: function checkIfItemContainsTextInLanguages(data, searchText) {

      if (!(0, _ramda.isNil)(data)) {
        for (var language in data) {
          if (!(0, _ramda.isNil)(data[language]) && _collection_utility.CollectionUtility.includes(data[language].toLowerCase(), searchText)) {
            return true;
          }
        }
      }
      return false;
    }
  }, {
    key: 'filterBySynonymAndOnlyReturnResultsWithDefaultShareclass',
    value: function filterBySynonymAndOnlyReturnResultsWithDefaultShareclass(searchText) {
      var autoCompleteData = this.state.autocompleteFundData;
      if (autoCompleteData.length === 0) {
        autoCompleteData = this.props.autocompleteFundData;
      }
      var results = _collection_utility.CollectionUtility.filter(autoCompleteData, function (item) {
        return _collection_utility.CollectionUtility.includes(item.synonymText.toLowerCase(), searchText) && item.isSynonym === true && item.sortOrder === 0;
      });

      if (results.length === 0) {
        return results;
      }

      var sortedResults = (0, _ramda.sortBy)((0, _ramda.path)(['cusip']))(results);
      return (0, _ramda.uniqBy)((0, _ramda.prop)('cusip'), sortedResults);
    }
  }, {
    key: 'getAutocompleteFundData',
    value: function getAutocompleteFundData() {
      var _this3 = this;

      var _props = this.props,
          gaiaRedirectUrl = _props.gaiaRedirectUrl,
          country = _props.country,
          role = _props.role,
          language = _props.language,
          userLoggedIn = _props.userLoggedIn,
          autocompleteFundData = _props.autocompleteFundData;


      if ((0, _ramda.isNil)(autocompleteFundData)) {
        var autocompleteServiceUrl = gaiaRedirectUrl + '/autocomplete?country=' + country + '&role=' + role + '&language=' + language + '&userLoggedIn=' + userLoggedIn + '&version=8.8_1746361865';
        _jquery2.default.get('' + autocompleteServiceUrl).then(function (data) {
          _this3.setState({ autocompleteFundData: data, errorMsg: "" });
        });
      }
    }
  }, {
    key: 'highlighter',
    value: function highlighter(searchResult) {
      var showShareClassName = this.props.showShareClassName;

      var formattedText = this.state.searchText.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&');
      var pattern = new RegExp("(" + formattedText + ")", "ig");
      var patternToReplaceWith = "<span class='caption font-dark-red font-light'>$1</span>";

      searchResult.cusip = searchResult.cusip.toUpperCase() === 'N/A' ? '-' : searchResult.cusip;
      var tickerOrCusip = searchResult.displayCusipOrIsin ? searchResult.cusip : searchResult.ticker;

      tickerOrCusip = tickerOrCusip.replace(pattern, patternToReplaceWith);

      var name = searchResult.name.replace(pattern, patternToReplaceWith);

      if (!(0, _ramda.isNil)(searchResult.translatedShareclassName)) {
        var language = void 0;
        if (!(0, _ramda.isNil)(searchResult.translatedShareclassName[this.props.language])) {
          language = this.props.language;
        } else if (!(0, _ramda.isNil)(this.languageTyped(this.state.searchText, searchResult.translatedShareclassName))) {
          language = this.languageTyped(this.state.searchText, searchResult.translatedShareclassName);
        } else {
          language = "en";
        }
        language = _url_utility2.default.getLanguageOverrideForJumpToFundResults(this.props.country) || language;
        name = searchResult.translatedShareclassName[language].replace(pattern, patternToReplaceWith);
      }

      if (showShareClassName) {
        name = searchResult.shareclassName.replace(pattern, patternToReplaceWith);
      }

      if (searchResult.category === 'Institutional') {
        searchResult.category = 'Inst.';
      }

      if (searchResult.category === 'Cash Management') {
        searchResult.category = 'Cash Mgmt.';
      }

      if (searchResult.fundType === 'sma') {
        tickerOrCusip = '';
      }

      if ((0, _ramda.or)(!(0, _ramda.isNil)(this.props.shouldShowCategory) && !this.props.shouldShowCategory, showShareClassName)) {
        searchResult.category = null;
        searchResult.categoryName = null;
      }

      var isCategoryAvailable = true;

      if ((0, _ramda.and)((0, _ramda.isNil)(searchResult.categoryName), (0, _ramda.isNil)(searchResult.category))) {
        isCategoryAvailable = false;
      }

      var line1Font = this.props.breakpoint > 3 ? 'disclaimer2' : 'tag';
      var line2Font = this.props.breakpoint > 3 ? 'disclaimer' : 'body2';

      var searchResultColumn = isCategoryAvailable ? _react2.default.createElement(
        'div',
        { className: 'text-right disclaimer col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xlg-4',
          'data-testid': 'category-result' },
        (0, _ramda.or)(searchResult.categoryName, searchResult.category)
      ) : null;
      var fundNameStyle = isCategoryAvailable ? "col-xs-8 col-sm-8 col-md-8 col-lg-8 col-xlg-8" : "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12";

      return _react2.default.createElement(
        'div',
        { className: 'row margin-horizontal-0' },
        _react2.default.createElement('div', { className: 'padding-horizontal-0 ' + line1Font + ' col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12',
          dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(tickerOrCusip) } }),
        _react2.default.createElement('div', { className: 'padding-horizontal-0 ' + line2Font + ' ' + fundNameStyle,
          dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(name) } }),
        searchResultColumn
      );
    }
  }, {
    key: 'showSuggestions',
    value: function showSuggestions() {
      var _this4 = this;

      var cursor = this.state.cursor;

      var parent = (0, _ramda.pathOr)(null, ["parent"], this.props);
      var pdpPath = (0, _ramda.pathOr)(null, ["pdpPath"], this.props);
      var anchorAttr = function anchorAttr(searchResult) {
        return {
          href: _location_service2.default.getPDPUrl(_this4.props.basePath, _location_service2.default.buildFundIdentifier(searchResult.shareclassName, searchResult.cusip), _this4.props.role, parent, pdpPath)
        };
      };
      return mapIndexed(function (searchResult, i) {
        var isHover = cursor === i;
        return _react2.default.createElement(
          'div',
          { ref: function ref(div) {
              return _this4['suggestion-' + i] = div;
            }, key: i,
            className: '' + (isHover ? 'suggestionitemwithhover suggestionitem ' : 'suggestionitem'),
            id: 'suggestionitem',
            'data-testid': 'search-result',
            role: 'presentation'
          },
          _react2.default.createElement(
            'a',
            _extends({}, anchorAttr(searchResult), {
              id: 'suggestionItem-' + i,
              role: 'option',
              onMouseDown: function onMouseDown() {
                var el = _this4['suggestion-' + i];
                el.className = "suggestionitem activeJTFSuggestion";
              },
              onMouseOut: function onMouseOut() {
                var el = _this4['suggestion-' + i];
                el.className = "suggestionitem";
              } }),
            _this4.highlighter(searchResult)
          )
        );
      }, this.state.searchResults);
    }
  }, {
    key: 'handleEnterKey',
    value: function handleEnterKey(e) {
      var parent = (0, _ramda.pathOr)(null, ["parent"], this.props);
      var pdpPath = (0, _ramda.pathOr)(null, ["pdpPath"], this.props);
      if (e.key === 'Enter') {
        var firstResult = this.state.searchResults[0];
        if (this.state.searchResults.length === 1) {
          var url = _location_service2.default.getPDPUrl(this.props.basePath, _location_service2.default.buildFundIdentifier(firstResult.shareclassName, firstResult.cusip), this.props.role, parent, pdpPath);
          if (!(0, _ramda.isNil)(parent) && parent === _constants2.default.getAEMParentString() && !(0, _ramda.isNil)(pdpPath)) {
            _location_service2.default.goTo(url);
          } else {
            _location_service2.default.setNewPDPLocation(url);
          }
        } else {
          var cursorPosition = this.state.cursor;
          var result = this.state.searchResults[cursorPosition];
          this.searchInput.val(result.name);
          this.setState({
            searchText: result.name,
            searchResults: this.state.searchResults.slice(cursorPosition, cursorPosition + 1)
          });
        }
      }
    }
  }, {
    key: 'handleOnFocus',
    value: function handleOnFocus() {
      var elOffset = null;

      var shouldShowHintPopup = this.props.appType !== 'jtf' && this.props.breakpoint > 3 ? true : false;

      var searchPlaceholderTextId = (0, _fund_utility.getSearchPlaceholderTextId)(this.props.country, this.props.role, null, true);
      var placeHolderText = _string_utility2.default.getLocalizedString(this.props.intl, 'Search by ', 'jump-to-fund-placeholder-prefix') + _string_utility2.default.getLocalizedString(this.props.intl, 'name, ticker or CUSIP', searchPlaceholderTextId + (this.props.breakpoint > 2 ? '' : '-for-mobile')).replace("Fund ", "").replace("Portfolio ", "");

      if (shouldShowHintPopup) {
        var el = document.getElementById(this.props.isStickyHeaderVisible ? 'jump-to-fund-sticky' : 'jump-to-fund');
        if (!(0, _ramda.isNil)(el)) {
          var elHeight = el.offsetHeight;
          var elWidth = el.offsetWidth;
          var elRect = el.getBoundingClientRect();
          var docTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;

          var offset = 6;
          var topPosition = this.props.isStickyHeaderVisible ? elRect.top + docTop + elHeight + offset : elRect.top + docTop - elHeight - offset;

          elOffset = {
            top: topPosition,
            left: elRect.left,
            toolTipWidth: elWidth,
            toolTipContentWidth: elWidth,
            showCrossIcon: false,
            reduceRightPadding: true,
            jtfTopPosition: elRect.top + docTop
          };
        }
      }

      if (shouldShowHintPopup) {
        this.props.tooltip.openTooltip(elOffset, placeHolderText, null, true);
        placeHolderText = '';
      }

      this.setState({
        searchBoxFocus: true, searchBoxPlaceholder: placeHolderText
      });
    }
  }, {
    key: 'handleOnBlur',
    value: function handleOnBlur() {
      if (this.props.appType !== 'jtf' && this.props.breakpoint > 3) {
        this.props.tooltip.closeTooltip();
      }
      this.searchInput.val().length < 1 ? this.setState({
        searchBoxFocus: false,
        searchBoxPlaceholder: _string_utility2.default.getLocalizedString(this.props.intl, 'Jump to a fund', 'pdp-jump-to-a-fund-search-placeholder', { role: this.props.role })
      }) : null;
    }
  }, {
    key: 'setSuggestionListStyle',
    value: function setSuggestionListStyle() {
      if (!this.props.openDropdown) {
        return 'display-none';
      }
      if (this.state.searchResults.length > 0) {
        if (this.state.searchResults.length === 1) {
          return 'suggestionitemwithhover suggestionsbox';
        }
        if (this.props.breakpoint < 4 && this.state.searchResults.length > 5) {
          return 'suggestionsbox height-330 overflow-y-scroll position-absolute';
        } else {
          return 'suggestionsbox';
        }
      } else {
        return 'display-none';
      }
    }
  }, {
    key: 'setErrorStyle',
    value: function setErrorStyle() {
      if (!this.props.openDropdown) {
        return 'display-none';
      }
      if (this.state.errorMsg !== '') {
        return 'suggestionsbox';
      } else {
        return 'display-none';
      }
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(e) {
      var _state = this.state,
          cursor = _state.cursor,
          searchResults = _state.searchResults;

      if (e.keyCode === 38 && cursor > 0) {
        this.setState({
          cursor: cursor - 1,
          hoveredId: 'suggestionItem-' + (cursor - 1)
        });
      } else if (e.keyCode === 40 && cursor < searchResults.length - 1) {
        this.setState({
          cursor: cursor + 1,
          hoveredId: 'suggestionItem-' + (cursor + 1)
        });
      }
    }
  }, {
    key: 'resetSearch',
    value: function resetSearch() {
      var _this5 = this;

      var trackingObject = {
        "eventCategory": _tracking_utility.TrackingUtility.getEventCategory(this.props.appType),
        "eventAction": "jump to a fund",
        "eventLabel": "clear"
      };
      _tracking_utility.TrackingUtility.trackEvent(trackingObject);
      this.searchInput.val('');
      this.setState({
        searchBoxFocus: false,
        searchBoxPlaceholder: _string_utility2.default.getLocalizedString(this.props.intl, 'Jump to a fund', 'pdp-jump-to-a-fund-search-placeholder', { role: this.props.role }),
        searchResults: [],
        errorMsg: '',
        searchText: ''
      });
      setTimeout(function () {
        _this5.jumpToFundWrapper.find('input').focus();
      }, 500);
    }
  }, {
    key: 'getJumpToFundStyle',
    value: function getJumpToFundStyle() {
      var defaultJTFStyleClassName = 'width-percent-100 padding-vertical-20';
      var _props2 = this.props,
          additionalMargin = _props2.additionalMargin,
          breakpoint = _props2.breakpoint,
          isStickyHeaderVisible = _props2.isStickyHeaderVisible;


      if ((0, _ramda.or)(this.props.appType === 'jtf', this.props.appType === "card")) {
        if (breakpoint < 3) {
          this.jumpToFundWrapper.parents().find('#parentContainer').css('margin-left', '15px');
        } else if ((0, _ramda.and)(breakpoint >= 3, !(0, _ramda.isNil)(this.jumpToFundWrapper))) {
          this.jumpToFundWrapper.parents().find('#parentContainer').css('margin-left', '0px');
        }
        return defaultJTFStyleClassName;
      }

      var styleClassName = 'width-percent-100';

      if (isStickyHeaderVisible) {
        styleClassName = 'width-percent-100 position-absolute right-0';
      }

      if (additionalMargin) {
        styleClassName += '' + additionalMargin;
      } else if (breakpoint < 3) {
        styleClassName = 'width-percent-100 padding-vertical-20';
      }

      return styleClassName;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var _props3 = this.props,
          breakpoint = _props3.breakpoint,
          isStickyHeaderVisible = _props3.isStickyHeaderVisible;

      var style = this.getJumpToFundStyle();

      return _react2.default.createElement(
        'div',
        { id: 'jump-to-fund',
          'data-testid': 'jump-to-fund',
          className: style + ' ' + (breakpoint < 3 ? "container" : "") + ' print-hide',
          style: breakpoint > 2 && !isStickyHeaderVisible ? {} : { "boxShadow": "0 7px 12px 0 rgba(0, 0, 0, 0.14)" },
          ref: function ref(div) {
            _this6.jumpToFundWrapper = (0, _jquery2.default)(div);
          } },
        _react2.default.createElement(
          'div',
          { className: 'row margin-all-0 overflow-x-hidden box-shadow font-slate-grey' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12 col-sm-12 padding-all-0' },
            _react2.default.createElement(
              'div',
              { id: 'searchdiv', 'data-testid': 'search-box',
                className: 'border-radius-4 ' + (this.state.searchText.length > 0 ? "border-bottom-2 border-pinkish-grey position-relative overflow-hidden" : "position-relative overflow-hidden") },
              _react2.default.createElement('input', { type: 'text',
                'aria-label': this.state.searchBoxAriaLabel,
                id: 'searchbox',
                'data-testid': 'searchbox',
                onChange: this.autoSuggest,
                onKeyPress: this.handleEnterKey,
                onKeyDown: this.handleKeyDown,
                onFocus: this.handleOnFocus,
                onBlur: this.handleOnBlur,
                autoComplete: 'off',
                className: 'height-38 category border-none padding-vertical-12 padding-left-16 padding-right-20 ',
                ref: function ref(input) {
                  _this6.searchInput = (0, _jquery2.default)(input);
                },
                role: 'combobox',
                'aria-expanded': this.state.searchResults.length > 0 ? 'true' : 'false',
                'aria-controls': 'suggestions',
                'aria-activedescendant': this.state.searchResults.length > 0 ? this.state.hoveredId : '',
                'aria-describedby': 'fundAlertsubcontText'
              }),
              _react2.default.createElement(
                'div',
                { id: 'jump-to-fund-placehoder',
                  className: (this.state.searchText.length > 0 ? "hidden" : "") + ' ' + (0, _fund_utility.getSearchPlaceholderStyle)(this.props.country, this.props.breakpoint, this.state.searchBoxFocus),
                  onClick: function onClick() {
                    _this6.searchInput.focus();
                  }
                },
                this.state.searchBoxPlaceholder
              ),
              _react2.default.createElement('span', { id: 'search-icon',
                onClick: this.resetSearch,
                onKeyDown: function onKeyDown(event) {
                  return _accessibility_utility2.default.handleEnterClick(_this6, event, _this6.resetSearch);
                },
                tabIndex: this.state.searchBoxFocus ? '0' : '-1',
                'aria-label': "clear input and search again",
                role: "button",
                className: 'margin-right-16 float-right position-relative margin-top--30 ' + (this.state.searchBoxFocus ? 'font-light icon-close' : 'icon-search') + ' ' })
            ),
            _react2.default.createElement(
              'div',
              { id: 'suggestions',
                className: 'width-percent-100 ' + this.setSuggestionListStyle(), role: 'listbox' },
              this.showSuggestions()
            ),
            _react2.default.createElement(
              'div',
              { id: 'noResultsError', className: 'width-percent-100 ' + this.setErrorStyle() },
              _react2.default.createElement(
                'div',
                {
                  className: 'row margin-horizontal-0 padding-vertical-10 padding-left-16 padding-right-16 category',
                  id: 'noResultsErrorMsg', role: "alert" },
                this.state.errorMsg
              )
            )
          )
        )
      );
    }
  }]);

  return JumpToFunds;
}(_react2.default.Component);

exports.default = (0, _ramda.compose)(function (component) {
  return (0, _reactIntl.injectIntl)(component, { withRef: false });
}, _withBreakpointResizeListener.withBreakpointResizeListener)(JumpToFunds);